import { Injectable } from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SvgIconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) { }

  /**
   *
   */
  public registerIcons(): void {
    this.loadIcons(Object.values(Icons), '../assets/icons');
  }

  /**
   *
   * @param iconKeys
   * @param iconUrl
   */
  private loadIcons(iconKeys: string[], iconUrl: string): void {
    iconKeys.forEach(key => {
      this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`));
    });
  }
}
export enum Icons {
  Farm = 'farm',
  Feed = 'feed',
  hen = 'hen',
  hina = 'hina',
  SaizaiSaiketsu = 'saizaiSaiketsu',
  Species = 'species',
  ChumonAdd = 'chumonAdd',
  ChumonList = 'chumonList',
  IkusuuLotAdd = 'ikusuuLotAdd',
  IkuseiLotAdd = 'ikuseiLotAdd',
  KeishaInfoList = 'keishaInfoList',
  Vaccine = 'vaccine',
  VaccineProgram = 'vaccineProgram',
}
